<template>
    <v-container fill-height
                 fluid
                 grid-list-xl>
        <v-layout wrap justify-center>
            <v-flex xs12 sm12 md8 lg8>
                <material-card class="card-tabs" color="green" title="Rating">
                    <v-container py-0>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-layout wrap>
                                <v-flex xs12 md12 d-flex>
                                    <v-spacer></v-spacer>
                                    <v-btn class="mx-0 font-weight-light"
                                           style="flex-grow: 0 !important;"
                                           color="tertiary"
                                           v-on:click="btnNewRate" v-if="!isCreate">
                                        <v-icon left>mdi-plus</v-icon>
                                        New Rate
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12
                                        md12 mt-4>
                                    <v-text-field class="purple-input"
                                                  label="Rate Name"
                                                  ref="rateName"
                                                  v-model="rate.name"
                                                  :rules="required"
                                                  required
                                                  @change="isUpdate=true"
                                                  autofocus/>
                                </v-flex>
                                <v-flex xs12
                                        md12>
                                    <v-text-field
                                            label="Rate Descriptions"
                                            v-model="rate.description"
                                            @change="isUpdate=true"/>
                                </v-flex>
                                <v-flex xs12 md12>
                                    <v-btn class="mx-0 font-weight-light"
                                           color="tertiary"
                                           v-if="isCreate" v-on:click="btnCreate">
                                        <v-icon left>mdi-plus</v-icon>
                                        Create
                                    </v-btn>
                                    <v-btn class="mx-0 font-weight-light"
                                           color="tertiary"
                                           v-if="!isCreate"
                                           :disabled="!isUpdate" v-on:click="btnSave">
                                        <v-icon left>mdi-content-save</v-icon>
                                        Save
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
                </material-card>
            </v-flex>
            <v-flex xs12 sm12 md4 lg4>
                <material-card class="card-tabs" color="green" title="List Rating">
                    <v-list three-line>
                        <v-list-tile v-for="rate_item in rates"
                                     v-bind:key="rate_item.token"
                                     v-on:click="fillRateData(rate_item)"
                                     active-class="highlighted"
                                     :class="rate.token === rate_item.token && !isCreate ? 'highlighted' : ''">
                            <v-list-tile-title>
                                {{rate_item.name}}
                            </v-list-tile-title>
                            <div class="d-flex">
                                <v-tooltip top
                                           content-class="top">
                                    <v-btn slot="activator"
                                           class="v-btn--simple"
                                           color="primary"
                                           icon
                                           @click.native.stop
                                           v-clipboard:copy="rate_item.token"
                                           v-clipboard:success="onCopySuccess"
                                           v-clipboard:error="onCopyError">
                                        <v-icon color="accent">mdi-content-copy</v-icon>
                                    </v-btn>
                                    <span>Coppy Token</span>
                                </v-tooltip>
                                <v-tooltip top
                                           content-class="top">
                                    <v-btn slot="activator"
                                           class="v-btn--simple"
                                           color="success"
                                           icon
                                           :to="'/rate-report/' + rate_item.token">
                                        <v-icon color="primary">mdi-google-analytics</v-icon>
                                    </v-btn>
                                    <span>Report</span>
                                </v-tooltip>
                                <v-tooltip top
                                           content-class="top">
                                    <v-btn slot="activator"
                                           class="v-btn--simple"
                                           color="danger"
                                           icon
                                           @click.native.stop
                                           v-on:click="btnDelete(rate_item)">
                                        <v-icon color="error">mdi-trash-can-outline</v-icon>
                                    </v-btn>
                                    <span>Delete</span>
                                </v-tooltip>
                            </div>
                        </v-list-tile>
                    </v-list>
                </material-card>
            </v-flex>
        </v-layout>
        <v-snackbar
                :color="snackbar.color"
                bottom
                right
                v-model="snackbar.show"
                dark>
            <v-icon color="white"
                    class="mr-3">
                {{snackbar.icon}}
            </v-icon>
            <div>{{snackbar.message}}</div>
            <v-icon size="16"
                    @click="snackbar.show = false">
                mdi-close-circle
            </v-icon>
        </v-snackbar>
    </v-container>
</template>

<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                valid: true,
                required: [v => !!v || "The field is required"],
                isCreate: true,
                isUpdate: false,
                rate: {},
                rates: [],
                snackbar: {
                    color: '',
                    message: '',
                    show: false,
                    icon: ''
                },
            }
        },
        created() {
            let self = this
            self.fetchData()
        },
        methods: {
            //Notify
            showSuccessNotify(message) {
                let self = this
                self.snackbar = {
                    color: 'success',
                    message: message,
                    show: true,
                    icon: 'mdi-information-variant'
                }
            },
            showErrorNotify(message) {
                let self = this
                self.snackbar = {
                    color: 'error',
                    message: message,
                    show: true,
                    icon: 'mdi-alert-circle-outline'
                }
            },
            //Rate method rest API
            async getRateItem() {
                return await axios.get('api/rate-item/', {withCredentials: true})
            },
            async getRateItemByToken(token) {
                return await axios.get('/api/rate-item/' + token + '/', {withCredentials: true})
            },
            async postRateItem(rate_item) {
                return await axios.post("api/rate-item/", rate_item, {
                    withCredentials: true
                })
            },
            async patchRateItem(rate_item) {
                return await axios.patch('/api/rate-item/' + rate_item.token + '/', rate_item, {withCredentials: true})
            },
            async deleteRateItem(rate_item) {
                return await axios.delete('api/rate-item/' + rate_item.token + '/', {withCredentials: true})
            },
            fetchData() {
                let self = this
                self.getRateItem()
                    .then((rates) => self.rates = rates.data)
                    .catch((error) => self.showErrorNotify('Have some error:' + error))
            },
            //Rate method UI
            btnNewRate() {
                let self = this
                self.$refs.form.reset()
                self.isCreate = true
                this.$refs.rateName.focus()
            },
            btnCreate() {
                let self = this
                if (self.$refs.form.validate()) {
                    self.postRateItem(self.rate)
                        .then((rate) => self.rate = rate.data)
                        .then(() => {
                            self.isCreate = false
                            self.isUpdate = false
                        })
                        .then(self.fetchData)
                        .then(self.showSuccessNotify('Create Rate Success'))
                        .catch((error) => self.showErrorNotify('Have some error:' + error))
                }
            },
            btnSave() {
                let self = this
                if (self.$refs.form.validate()) {
                    self.patchRateItem(self.rate)
                        .then((rate) => self.rate = rate.data)
                        .then(self.fetchData)
                        .then(() => self.isUpdate = false)
                        .then(self.showSuccessNotify('Update Rate Success'))
                        .catch((error) => self.showErrorNotify('Have some error:' + error))
                }
            },
            btnDelete(rate) {
                let self = this
                self.$confirm('Are you sure to delete this item?').then((res) => {
                    if (res) {
                        self.deleteRateItem(rate)
                            .then(self.fetchData)
                            .then(self.showSuccessNotify('Delete Question Success'))
                            .then(() => {
                                if (rate.token == self.rate.token) {
                                    self.btnNewRate()
                                }
                            })
                            .catch((error) => self.showErrorNotify('Have some error:' + error))
                    }

                })
            },
            fillRateData(rate) {
                let self = this
                self.isCreate = false
                self.isUpdate = true
                self.rate = rate
                self.fetchData()
            },
            onCopySuccess() {
                let self = this
                self.showSuccessNotify('Copy Token Success')
            },
            onCopyError() {
                let self = this
                self.showErrorNotify('Copy Token Error')
            }
        }
    }
</script>

<style scoped>
    .highlighted {
        background-color: rgba(0, 0, 0, .04);
    }
</style>